import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=680dad9e&scoped=true&v-on-clickaway=cancel&"
import script from "./Questions.vue?vue&type=script&lang=ts&"
export * from "./Questions.vue?vue&type=script&lang=ts&"
import style0 from "./Questions.vue?vue&type=style&index=0&id=680dad9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680dad9e",
  null
  
)

export default component.exports